const containers = document.querySelectorAll(".viewer-canvas")
console.log("🚀 ~ containers:", containers)

let starColors = [null, null, null, null]
var starMeshesContainers = []

containers.forEach((container) => {
  const canvasEl = container.querySelector(".three-canvas")
  console.log("🚀 ~ canvasEl:", canvasEl)

  var SINGLE_PTS =
    "448.92,235.16 517.52,371.18 668.08,394.39 559.91,501.67 584.37,652.03 448.92,582.31 313.47,652.03 337.92,501.67 229.75,394.39 380.32,371.18"
  var VB = "160 180 560 500"
  var COLORS = [
    { hex: "#F9423A", name: "cherry tomato" },
    { hex: "#643230", name: "fig" },
    { hex: "#FFC9E5", name: "cotton candy" },
    { hex: "#FF40B4", name: "jelly bean" },
    { hex: "#FE6B00", name: "goldfish" },
    { hex: "#FF8D6C", name: "creamsicle" },
    { hex: "#EBAA00", name: "honey comb" },
    { hex: "#5E7E29", name: "olive" },
    { hex: "#92D500", name: "slime" },
    { hex: "#9DE7D7", name: "scuba" },
    { hex: "#00C4B3", name: "lagoon" },
    { hex: "#B9D9EB", name: "sky" },
    { hex: "#0055B8", name: "neptune" },
    { hex: "#002F6D", name: "deep sea" },
    { hex: "#753BBD", name: "grape soda" },
    { hex: "#C0ADE7", name: "butterfly" },
    { hex: "#2D2A26", name: "black" },
    { hex: "#898C8D", name: "mist" },
    { hex: "#EBEEF0", name: "shell" },
    { hex: "#FFFFFF", name: "white" },
  ]
  var selectedSlot = 0,
    starColors = [null, null, null, null]

  var renderer = new THREE.WebGLRenderer({
    canvas: canvasEl,
    antialias: true,
    preserveDrawingBuffer: true,
  })
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  var scene = new THREE.Scene()
  var camera = new THREE.PerspectiveCamera(40, 1, 0.1, 100)
  camera.position.set(0, 0, 9)

  // ── Solid background ─────────────────────────────────────────────────────
  // ── Background ───────────────────────────────────────────────────────────
  scene.background = new THREE.Color("#FFFFFF")

  scene.add(new THREE.AmbientLight(0xffffff, 0.55))
  var kLight = new THREE.DirectionalLight(0xffffff, 0.69)
  kLight.position.set(2.4, 0.2, 0.4)
  scene.add(kLight)
  var fLight = new THREE.DirectionalLight(0xfff8f0, 0.48)
  fLight.position.set(-3.9, 2, 4)
  scene.add(fLight)
  var rLight = new THREE.DirectionalLight(0xaaddff, 1.0)
  rLight.position.set(1.7, 2.3, -7.3)
  scene.add(rLight)
  var bLight = new THREE.DirectionalLight(0xffffff, 0.6)
  bLight.position.set(10, 10, -6)
  scene.add(bLight)

  // ── Paper bump texture (from v62) ────────────────────────────────────────
  function createPaperTexture() {
    var sz = 512,
      c = document.createElement("canvas")
    c.width = sz
    c.height = sz
    var ctx = c.getContext("2d")
    ctx.fillStyle = "#ffffff"
    ctx.fillRect(0, 0, sz, sz)
    var img = ctx.getImageData(0, 0, sz, sz),
      d = img.data
    for (var i = 0; i < d.length; i += 4) {
      var n = (Math.random() - 0.5) * 28
      d[i] = Math.min(255, Math.max(0, d[i] + n))
      d[i + 1] = Math.min(255, Math.max(0, d[i + 1] + n))
      d[i + 2] = Math.min(255, Math.max(0, d[i + 2] + n))
    }
    ctx.putImageData(img, 0, 0)
    ctx.globalAlpha = 0.03
    ctx.strokeStyle = "#888"
    for (var f = 0; f < 80; f++) {
      ctx.beginPath()
      var sx = Math.random() * sz,
        sy = Math.random() * sz
      ctx.moveTo(sx, sy)
      ctx.lineTo(sx + (Math.random() - 0.5) * 60, sy + (Math.random() - 0.5) * 8)
      ctx.lineWidth = Math.random() * 1.2 + 0.3
      ctx.stroke()
    }
    ctx.globalAlpha = 1
    var tex = new THREE.CanvasTexture(c)
    tex.wrapS = THREE.RepeatWrapping
    tex.wrapT = THREE.RepeatWrapping
    tex.repeat.set(2, 2)
    return tex
  }
  var paperTex = createPaperTexture()

  // ── SVG Shape Parser ─────────────────────────────────────────────────────
  function parseSVGtoShape(svgText) {
    var parser = new DOMParser(),
      doc = parser.parseFromString(svgText, "image/svg+xml"),
      paths = doc.querySelectorAll("path")
    if (!paths.length) return null
    var d = paths[0].getAttribute("d")
    if (!d) return null
    var tokens = d.match(
      /[MmLlHhVvCcSsQqTtAaZz]|[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?/g,
    )
    if (!tokens) return null
    var i = 0
    function num() {
      return parseFloat(tokens[i++])
    }
    function isNum() {
      return i < tokens.length && /^[-+0-9.]/.test(tokens[i])
    }
    var cmds = [],
      cx = 0,
      cy = 0,
      sx = 0,
      sy = 0,
      lc1x = 0,
      lc1y = 0
    while (i < tokens.length) {
      var cmd = tokens[i]
      if (!/^[A-Za-z]$/.test(cmd)) {
        i++
        continue
      }
      i++
      if (cmd === "M") {
        while (isNum()) {
          cx = num()
          cy = num()
          sx = cx
          sy = cy
          cmds.push({ t: "M", x: cx, y: cy })
        }
      } else if (cmd === "m") {
        while (isNum()) {
          cx += num()
          cy += num()
          sx = cx
          sy = cy
          cmds.push({ t: "M", x: cx, y: cy })
        }
      } else if (cmd === "L") {
        while (isNum()) {
          cx = num()
          cy = num()
          cmds.push({ t: "L", x: cx, y: cy })
        }
      } else if (cmd === "l") {
        while (isNum()) {
          cx += num()
          cy += num()
          cmds.push({ t: "L", x: cx, y: cy })
        }
      } else if (cmd === "H") {
        while (isNum()) {
          cx = num()
          cmds.push({ t: "L", x: cx, y: cy })
        }
      } else if (cmd === "h") {
        while (isNum()) {
          cx += num()
          cmds.push({ t: "L", x: cx, y: cy })
        }
      } else if (cmd === "V") {
        while (isNum()) {
          cy = num()
          cmds.push({ t: "L", x: cx, y: cy })
        }
      } else if (cmd === "v") {
        while (isNum()) {
          cy += num()
          cmds.push({ t: "L", x: cx, y: cy })
        }
      } else if (cmd === "C") {
        while (isNum()) {
          var c1x = num(),
            c1y = num(),
            c2x = num(),
            c2y = num(),
            ex = num(),
            ey = num()
          cmds.push({
            t: "C",
            c1x: c1x,
            c1y: c1y,
            c2x: c2x,
            c2y: c2y,
            x: ex,
            y: ey,
          })
          lc1x = c2x
          lc1y = c2y
          cx = ex
          cy = ey
        }
      } else if (cmd === "c") {
        while (isNum()) {
          var dc1x = num(),
            dc1y = num(),
            dc2x = num(),
            dc2y = num(),
            dex = num(),
            dey = num()
          var c1x = cx + dc1x,
            c1y = cy + dc1y,
            c2x = cx + dc2x,
            c2y = cy + dc2y,
            ex = cx + dex,
            ey = cy + dey
          cmds.push({
            t: "C",
            c1x: c1x,
            c1y: c1y,
            c2x: c2x,
            c2y: c2y,
            x: ex,
            y: ey,
          })
          lc1x = c2x
          lc1y = c2y
          cx = ex
          cy = ey
        }
      } else if (cmd === "S") {
        while (isNum()) {
          var c1x = 2 * cx - lc1x,
            c1y = 2 * cy - lc1y
          var c2x = num(),
            c2y = num(),
            ex = num(),
            ey = num()
          cmds.push({
            t: "C",
            c1x: c1x,
            c1y: c1y,
            c2x: c2x,
            c2y: c2y,
            x: ex,
            y: ey,
          })
          lc1x = c2x
          lc1y = c2y
          cx = ex
          cy = ey
        }
      } else if (cmd === "s") {
        while (isNum()) {
          var c1x = 2 * cx - lc1x,
            c1y = 2 * cy - lc1y
          var dc2x = num(),
            dc2y = num(),
            dex = num(),
            dey = num()
          var c2x = cx + dc2x,
            c2y = cy + dc2y,
            ex = cx + dex,
            ey = cy + dey
          cmds.push({
            t: "C",
            c1x: c1x,
            c1y: c1y,
            c2x: c2x,
            c2y: c2y,
            x: ex,
            y: ey,
          })
          lc1x = c2x
          lc1y = c2y
          cx = ex
          cy = ey
        }
      } else if (cmd === "Q") {
        while (isNum()) {
          var qx = num(),
            qy = num(),
            ex = num(),
            ey = num()
          cmds.push({ t: "Q", qx: qx, qy: qy, x: ex, y: ey })
          cx = ex
          cy = ey
        }
      } else if (cmd === "q") {
        while (isNum()) {
          var dqx = num(),
            dqy = num(),
            dex = num(),
            dey = num()
          cmds.push({
            t: "Q",
            qx: cx + dqx,
            qy: cy + dqy,
            x: cx + dex,
            y: cy + dey,
          })
          cx += dex
          cy += dey
        }
      } else if (cmd === "Z" || cmd === "z") {
        cmds.push({ t: "Z" })
        cx = sx
        cy = sy
      } else {
        while (isNum()) num()
      }
    }
    if (cmds.length < 2) return null
    var allPts = []
    cmds.forEach(function (c) {
      if (c.x !== undefined) allPts.push({ x: c.x, y: c.y })
      if (c.c1x !== undefined) {
        allPts.push({ x: c.c1x, y: c.c1y })
        allPts.push({ x: c.c2x, y: c.c2y })
      }
      if (c.qx !== undefined) allPts.push({ x: c.qx, y: c.qy })
    })
    var mnX = Infinity,
      mxX = -Infinity,
      mnY = Infinity,
      mxY = -Infinity
    allPts.forEach(function (p) {
      if (p.x < mnX) mnX = p.x
      if (p.x > mxX) mxX = p.x
      if (p.y < mnY) mnY = p.y
      if (p.y > mxY) mxY = p.y
    })
    var cxC = (mnX + mxX) / 2,
      cyC = (mnY + mxY) / 2,
      sc = 2 / Math.max(mxX - mnX, mxY - mnY)
    function tx(x) {
      return (x - cxC) * sc
    }
    function ty(y) {
      return -(y - cyC) * sc
    }
    var shape = new THREE.Shape()
    cmds.forEach(function (c) {
      if (c.t === "M") shape.moveTo(tx(c.x), ty(c.y))
      else if (c.t === "L") shape.lineTo(tx(c.x), ty(c.y))
      else if (c.t === "C")
        shape.bezierCurveTo(
          tx(c.c1x),
          ty(c.c1y),
          tx(c.c2x),
          ty(c.c2y),
          tx(c.x),
          ty(c.y),
        )
      else if (c.t === "Q") shape.quadraticCurveTo(tx(c.qx), ty(c.qy), tx(c.x), ty(c.y))
      else if (c.t === "Z") shape.closePath()
    })
    return shape
  }
  var starShape = (function () {
    var svgD =
      "M228.71,86.45c-.02-2.08-1.41-4.05-3.76-4.42l-72.01-11.1L120.12,5.88c-.84-1.64-2.37-2.42-3.96-2.43-1.6.01-3.13.79-3.97,2.43l-32.8,65.06L7.37,82.04c-2.36.37-3.74,2.34-3.76,4.42,0,1.11.39,2.2,1.31,3.12l51.74,51.3-11.7,71.91-.06.75c0,2.47,2.1,4.4,4.43,4.41.66,0,1.34-.15,2.03-.51l64.78-33.34,64.79,33.34c.69.36,1.37.51,2.03.51,2.33,0,4.43-1.94,4.43-4.41l-.06-.75-11.69-71.91,51.73-51.3c.92-.92,1.31-2.01,1.32-3.12Z"
    return parseSVGtoShape(
      '<?xml version="1.0"?><svg xmlns="http://www.w3.org/2000/svg"><path d="' +
        svgD +
        '"/></svg>',
    )
  })()

  // ── Geometry pipeline ────────────────────────────────────────────────────
  function mid3(a, b) {
    return [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2, (a[2] + b[2]) / 2]
  }
  function mid2(a, b) {
    return [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2]
  }
  function pushT(pA, uA, p0, p1, p2, u0, u1, u2) {
    pA.push(p0[0], p0[1], p0[2], p1[0], p1[1], p1[2], p2[0], p2[1], p2[2])
    uA.push(u0[0], u0[1], u1[0], u1[1], u2[0], u2[1])
  }
  function tessellateGeom(ig) {
    if (ig.index) ig = ig.toNonIndexed()
    var pos = ig.attributes.position.array,
      uv = ig.attributes.uv ? ig.attributes.uv.array : null,
      tc = pos.length / 9,
      np = [],
      nu = []
    for (var t = 0; t < tc; t++) {
      var o = t * 9,
        ou = t * 6
      var p0 = [pos[o], pos[o + 1], pos[o + 2]],
        p1 = [pos[o + 3], pos[o + 4], pos[o + 5]],
        p2 = [pos[o + 6], pos[o + 7], pos[o + 8]]
      var u0 = uv ? [uv[ou], uv[ou + 1]] : [0, 0],
        u1 = uv ? [uv[ou + 2], uv[ou + 3]] : [0, 0],
        u2 = uv ? [uv[ou + 4], uv[ou + 5]] : [0, 0]
      var m01 = mid3(p0, p1),
        m12 = mid3(p1, p2),
        m02 = mid3(p0, p2),
        mu01 = mid2(u0, u1),
        mu12 = mid2(u1, u2),
        mu02 = mid2(u0, u2)
      pushT(np, nu, p0, m01, m02, u0, mu01, mu02)
      pushT(np, nu, m01, p1, m12, mu01, u1, mu12)
      pushT(np, nu, m02, m12, p2, mu02, mu12, u2)
      pushT(np, nu, m01, m12, m02, mu01, mu12, mu02)
    }
    var g = new THREE.BufferGeometry()
    g.setAttribute("position", new THREE.Float32BufferAttribute(np, 3))
    g.setAttribute("uv", new THREE.Float32BufferAttribute(nu, 2))
    return g
  }
  function mergeAndSmooth(geom) {
    var pos = geom.attributes.position.array,
      uv = geom.attributes.uv ? geom.attributes.uv.array : null,
      eps = 0.0001,
      vm = {},
      up = [],
      uu = [],
      idx = []
    for (var i = 0; i < pos.length / 3; i++) {
      var x = pos[i * 3],
        y = pos[i * 3 + 1],
        z = pos[i * 3 + 2],
        k = Math.round(x / eps) + "," + Math.round(y / eps) + "," + Math.round(z / eps)
      if (vm[k] === undefined) {
        vm[k] = up.length / 3
        up.push(x, y, z)
        if (uv) uu.push(uv[i * 2], uv[i * 2 + 1])
      }
      idx.push(vm[k])
    }
    var g = new THREE.BufferGeometry()
    g.setAttribute("position", new THREE.Float32BufferAttribute(up, 3))
    if (uv) g.setAttribute("uv", new THREE.Float32BufferAttribute(uu, 2))
    g.setIndex(idx)
    g.computeVertexNormals()
    return g
  }
  function makeStarGeoms(depth, shape) {
    if (depth === undefined) depth = 0.03
    if (!shape) shape = starShape
    var bT = depth * 0.3
    var src = new THREE.ExtrudeGeometry(shape, {
      depth: depth,
      bevelEnabled: true,
      bevelThickness: bT,
      bevelSize: bT,
      bevelSegments: 6,
      curveSegments: 48,
    })
    src.center()
    var sNI = src.index ? src.toNonIndexed() : src
    var pos = sNI.attributes.position.array,
      uv = sNI.attributes.uv ? sNI.attributes.uv.array : null
    var fP = [],
      fU = [],
      bP = [],
      bU = [],
      sP = [],
      sU = []
    var tc = pos.length / 9
    for (var t = 0; t < tc; t++) {
      var o = t * 9,
        ou = t * 6
      var ax = pos[o + 3] - pos[o],
        ay = pos[o + 4] - pos[o + 1],
        az = pos[o + 5] - pos[o + 2],
        bx = pos[o + 6] - pos[o],
        by = pos[o + 7] - pos[o + 1],
        bz = pos[o + 8] - pos[o + 2]
      var nx = ay * bz - az * by,
        ny = az * bx - ax * bz,
        nz = ax * by - ay * bx,
        len = Math.sqrt(nx * nx + ny * ny + nz * nz)
      if (len > 0) {
        nx /= len
        ny /= len
        nz /= len
      }
      var tp, tu
      if (nz > 0.5) {
        tp = fP
        tu = fU
      } else if (nz < -0.5) {
        tp = bP
        tu = bU
      } else {
        tp = sP
        tu = sU
      }
      for (var v = 0; v < 3; v++) {
        tp.push(pos[o + v * 3], pos[o + v * 3 + 1], pos[o + v * 3 + 2])
        if (uv) tu.push(uv[ou + v * 2], uv[ou + v * 2 + 1])
      }
    }
    function bg(p, u) {
      var g = new THREE.BufferGeometry()
      g.setAttribute("position", new THREE.Float32BufferAttribute(p, 3))
      if (u.length) g.setAttribute("uv", new THREE.Float32BufferAttribute(u, 2))
      g = tessellateGeom(g)
      g = tessellateGeom(g)
      g = mergeAndSmooth(g)
      return g
    }
    return { front: bg(fP, fU), back: bg(bP, bU), sides: bg(sP, sU) }
  }

  // ── Deformation ──────────────────────────────────────────────────────────
  function applyDeform(geoms, bendX, bendY) {
    for (var gi = 0; gi < geoms.length; gi++) {
      var geom = geoms[gi],
        pos = geom.attributes.position,
        bp = geom.userData.basePositions
      if (!bp) {
        bp = new Float32Array(pos.array)
        geom.userData.basePositions = bp
      }
      for (var i = 0; i < pos.count; i++) {
        var bx = bp[i * 3],
          by = bp[i * 3 + 1],
          bz = bp[i * 3 + 2],
          z = bz
        if (Math.abs(bendX) > 0.001) z += bendX * bx * bx * 0.35
        if (Math.abs(bendY) > 0.001) z += bendY * by * by * 0.35
        pos.array[i * 3] = bx
        pos.array[i * 3 + 1] = by
        pos.array[i * 3 + 2] = z
      }
      pos.needsUpdate = true
      geom.computeVertexNormals()
      geom.computeBoundingSphere()
    }
  }

  // ── Stars ────────────────────────────────────────────────────────────────
  var N = 4,
    SCALE = 0.8
  var fixedPos = [
    new THREE.Vector3(-1.35, 1.45, 0),
    new THREE.Vector3(1.35, 1.45, 0),
    new THREE.Vector3(-1.35, -1.45, 0),
    new THREE.Vector3(1.35, -1.45, 0),
  ]
  function tintToWhite(hex) {
    var c = new THREE.Color(hex)
    c.r += (1 - c.r) * 0.5
    c.g += (1 - c.g) * 0.5
    c.b += (1 - c.b) * 0.5
    return c
  }

  var starParams = [
    {
      tiltX: 1,
      tiltZ: -6,
      facingY: 4,
      spinSpd: 50,
      spinRange: 13,
      wobX: 100,
      wobZ: 65,
      bendXoff: 47,
      bendYoff: 26,
      bendAmp: 7,
      bendSpd: 45,
      phase: 0,
    },
    {
      tiltX: -6,
      tiltZ: 13,
      facingY: -7,
      spinSpd: 50,
      spinRange: 20,
      wobX: 40,
      wobZ: 25,
      bendXoff: -12,
      bendYoff: -38,
      bendAmp: 16,
      bendSpd: 25,
      phase: 1.3,
    },
    {
      tiltX: 1,
      tiltZ: 19,
      facingY: -1,
      spinSpd: 53,
      spinRange: 19,
      wobX: 21,
      wobZ: 47,
      bendXoff: 0,
      bendYoff: 21,
      bendAmp: 14,
      bendSpd: 20,
      phase: 2.8,
    },
    {
      tiltX: -35,
      tiltZ: -19,
      facingY: -25,
      spinSpd: 50,
      spinRange: 20,
      wobX: 25,
      wobZ: 18,
      bendXoff: 18,
      bendYoff: -29,
      bendAmp: 14,
      bendSpd: 24,
      phase: 4.1,
    },
  ]

  var starData = [],
    meshes = []
  for (var i = 0; i < N; i++) {
    var sg = makeStarGeoms(0.055)
    sg.front.userData.basePositions = new Float32Array(
      sg.front.attributes.position.array,
    )
    sg.back.userData.basePositions = new Float32Array(sg.back.attributes.position.array)
    sg.sides.userData.basePositions = new Float32Array(
      sg.sides.attributes.position.array,
    )
    var geomArr = [sg.front, sg.back, sg.sides]
    // Store original unbent positions
    var origPositions = [
      new Float32Array(sg.front.attributes.position.array),
      new Float32Array(sg.back.attributes.position.array),
      new Float32Array(sg.sides.attributes.position.array),
    ]
    // Apply initial bend
    var sp = starParams[i]
    applyDeform(geomArr, sp.bendXoff / 100, sp.bendYoff / 100)
    sg.front.userData.basePositions = new Float32Array(
      sg.front.attributes.position.array,
    )
    sg.back.userData.basePositions = new Float32Array(sg.back.attributes.position.array)
    sg.sides.userData.basePositions = new Float32Array(
      sg.sides.attributes.position.array,
    )
    starData.push({ geoms: geomArr, origPositions: origPositions })
    var fm = new THREE.MeshLambertMaterial({
      color: 0xdddddd,
    })

    var em = new THREE.MeshLambertMaterial({
      color: tintToWhite("#dddddd"),
      side: THREE.DoubleSide,
    })
    var gr = new THREE.Group()
    gr.add(new THREE.Mesh(sg.front, fm))
    gr.add(new THREE.Mesh(sg.back, em))
    gr.add(new THREE.Mesh(sg.sides, em))
    gr.scale.setScalar(SCALE)
    gr.position.set(fixedPos[i].x * SCALE, fixedPos[i].y * SCALE, 0)
    scene.add(gr)
    meshes.push({ group: gr, frontMat: fm, edgeMat: em })
  }

  // Re-apply bend from clean geometry
  function reapplyBend(starIdx) {
    var sd = starData[starIdx],
      sp = starParams[starIdx]
    for (var g = 0; g < 3; g++) {
      sd.geoms[g].userData.basePositions = new Float32Array(sd.origPositions[g])
    }
    applyDeform(sd.geoms, sp.bendXoff / 100, sp.bendYoff / 100)
    for (var g = 0; g < 3; g++) {
      sd.geoms[g].userData.basePositions = new Float32Array(
        sd.geoms[g].attributes.position.array,
      )
    }
  }

  // ── Drop shadow system ───────────────────────────────────────────────────
  var shadowSettings = {
    opacity: 0.09,
    blur: 34,
    size: 200,
    offX: 0.1,
    offY: -0.1,
    zDepth: -1,
  }

  function makeShadowTexture(blur) {
    var sz = 256,
      c = document.createElement("canvas")
    c.width = sz
    c.height = sz
    var ctx = c.getContext("2d")
    var svgD =
      "M228.71,86.45c-.02-2.08-1.41-4.05-3.76-4.42l-72.01-11.1L120.12,5.88c-.84-1.64-2.37-2.42-3.96-2.43-1.6.01-3.13.79-3.97,2.43l-32.8,65.06L7.37,82.04c-2.36.37-3.74,2.34-3.76,4.42,0,1.11.39,2.2,1.31,3.12l51.74,51.3-11.7,71.91-.06.75c0,2.47,2.1,4.4,4.43,4.41.66,0,1.34-.15,2.03-.51l64.78-33.34,64.79,33.34c.69.36,1.37.51,2.03.51,2.33,0,4.43-1.94,4.43-4.41l-.06-.75-11.69-71.91,51.73-51.3c.92-.92,1.31-2.01,1.32-3.12Z"
    var svgScale = (sz / 232) * 0.55
    var offX = (sz - 232 * svgScale) / 2,
      offY = (sz - 221 * svgScale) / 2
    ctx.save()
    ctx.translate(offX, offY)
    ctx.scale(svgScale, svgScale)
    var path = new Path2D(svgD)
    ctx.fillStyle = "rgba(0,0,0,1)"
    ctx.fill(path)
    ctx.restore()
    // Manual box blur (works everywhere, no ctx.filter dependency)
    var r = Math.max(1, Math.round(blur / 2))
    for (var pass = 0; pass < 3; pass++) boxBlurAlpha(ctx, sz, sz, r)
    var tex = new THREE.CanvasTexture(c)
    tex.needsUpdate = true
    return tex
  }
  function boxBlurAlpha(ctx, w, h, r) {
    var src = ctx.getImageData(0, 0, w, h)
    var d = src.data
    var tmp = new Uint8ClampedArray(d.length)
    // Horizontal pass
    for (var y = 0; y < h; y++) {
      var row = y * w * 4
      var sum = 0,
        count = 0
      // prime window
      for (var k = -r; k <= r; k++) {
        var xx = Math.max(0, Math.min(w - 1, k))
        sum += d[row + xx * 4 + 3]
        count++
      }
      for (var x = 0; x < w; x++) {
        tmp[row + x * 4 + 3] = sum / count
        var xAdd = Math.min(w - 1, x + r + 1),
          xRem = Math.max(0, x - r)
        sum += d[row + xAdd * 4 + 3] - d[row + xRem * 4 + 3]
      }
    }
    // Vertical pass
    for (var x = 0; x < w; x++) {
      var sum = 0,
        count = 0
      for (var k = -r; k <= r; k++) {
        var yy = Math.max(0, Math.min(h - 1, k))
        sum += tmp[(yy * w + x) * 4 + 3]
        count++
      }
      for (var y = 0; y < h; y++) {
        d[(y * w + x) * 4 + 3] = sum / count
        d[(y * w + x) * 4] = 0
        d[(y * w + x) * 4 + 1] = 0
        d[(y * w + x) * 4 + 2] = 0
        var yAdd = Math.min(h - 1, y + r + 1),
          yRem = Math.max(0, y - r)
        sum += tmp[(yAdd * w + x) * 4 + 3] - tmp[(yRem * w + x) * 4 + 3]
      }
    }
    ctx.putImageData(src, 0, 0)
  }

  var shadowTex = makeShadowTexture(shadowSettings.blur)
  var shadowPlaneGeom = new THREE.PlaneGeometry(2, 2)
  var shadowMeshes = []
  for (var i = 0; i < N; i++) {
    var sMat = new THREE.MeshBasicMaterial({
      map: shadowTex,
      transparent: true,
      opacity: shadowSettings.opacity,
      depthWrite: false,
      side: THREE.DoubleSide,
    })
    var sMesh = new THREE.Mesh(shadowPlaneGeom, sMat)
    var ssz = (shadowSettings.size / 100) * SCALE
    sMesh.scale.set(ssz, ssz, 1)
    sMesh.position.set(
      fixedPos[i].x * SCALE + shadowSettings.offX * 0.1,
      fixedPos[i].y * SCALE + shadowSettings.offY * 0.1,
      shadowSettings.zDepth,
    )
    scene.add(sMesh)
    shadowMeshes.push(sMesh)
  }
  function updateShadows() {
    for (var i = 0; i < N; i++) {
      var ssz = (shadowSettings.size / 100) * SCALE
      shadowMeshes[i].scale.set(ssz, ssz, 1)
      shadowMeshes[i].material.opacity = shadowSettings.opacity
      shadowMeshes[i].position.z = shadowSettings.zDepth
    }
  }
  function rebuildShadowTex() {
    shadowTex.dispose()
    shadowTex = makeShadowTexture(shadowSettings.blur)
    for (var i = 0; i < N; i++) {
      shadowMeshes[i].material.map = shadowTex
      shadowMeshes[i].material.needsUpdate = true
    }
  }

  function resize() {
    var w = container.offsetWidth,
      h = container.offsetHeight
    if (!w || !h) return
    renderer.setSize(w, h, false)
    camera.aspect = w / h
    camera.updateProjectionMatrix()
  }
  new ResizeObserver(resize).observe(container)
  resize()

  // ── Animate ──────────────────────────────────────────────────────────────
  var bobParams = [
    { amp: 0.06, spd: 0.0035, phase: 0 },
    { amp: 0.05, spd: 0.0045, phase: 1.8 },
    { amp: 0.07, spd: 0.003, phase: 3.5 },
    { amp: 0.05, spd: 0.004, phase: 5.0 },
  ]
  var frame = 0
  function animate() {
    requestAnimationFrame(animate)
    frame++
    for (var i = 0; i < N; i++) {
      var sp = starParams[i]
      var sSpd = sp.spinSpd / 6000,
        sRange = (sp.spinRange * Math.PI) / 180
      var fY = (sp.facingY * Math.PI) / 180
      var oscY = Math.sin(frame * sSpd + sp.phase) * sRange
      var tX = (sp.tiltX * Math.PI) / 180,
        tZ = (sp.tiltZ * Math.PI) / 180
      var wXa = sp.wobX / 500,
        wZa = sp.wobZ / 500
      var wXv = Math.sin(frame * 0.0045 + sp.phase * 1.3) * wXa
      var wZv = Math.sin(frame * 0.0055 + sp.phase * 1.7) * wZa
      meshes[i].group.rotation.set(tX + wXv, fY + oscY, tZ + wZv)
      var bb = bobParams[i]
      var bobY = Math.sin(frame * bb.spd + bb.phase) * bb.amp
      meshes[i].group.position.y = fixedPos[i].y * SCALE + bobY
      shadowMeshes[i].position.x =
        meshes[i].group.position.x + shadowSettings.offX * 0.1
      shadowMeshes[i].position.y =
        meshes[i].group.position.y + shadowSettings.offY * 0.1
    }
    renderer.render(scene, camera)
  }
  animate()

  // ── Color configurator ──────────────────────────────────────────────────
  var baseRoughness = 1.0,
    baseMetalness = 0.0
  var VIEWER_COLOR_MAP = { "#FFFFFF": "#F8F8F8", "#EBEEF0": "#DCE2E5" }
  function viewerHex(hex) {
    return VIEWER_COLOR_MAP[hex.toUpperCase()] || hex
  }

  // Per-color material rules
  function colorLuminance(hex) {
    var c = new THREE.Color(hex)
    return 0.299 * c.r + 0.587 * c.g + 0.114 * c.b
  }

  // Explicit overrides for specific hex codes that need special treatment
  var COLOR_RULES = {
    "#FFC9E5": { roughness: 0.72, metalness: 0.0 }, // light pink — push roughness up
    "#C0ADE7": { roughness: 0.7, metalness: 0.0 }, // light purple
    "#B9D9EB": { roughness: 0.72, metalness: 0.0 }, // light blue
    "#9DE7D7": { roughness: 0.7, metalness: 0.0 }, // light teal
  }

  function getMaterialRules(hex) {
    var upper = hex.toUpperCase()
    // Check explicit overrides first
    if (COLOR_RULES[upper]) return COLOR_RULES[upper]
    // Then luminance-based fallback
    var lum = colorLuminance(hex)
    if (lum < 0.08) return { roughness: 0.45, metalness: 0.04 }
    if (lum < 0.15) return { roughness: 0.5, metalness: 0.03 }
    if (lum > 0.9) return { roughness: 0.75, metalness: 0.0 }
    if (lum > 0.75) return { roughness: 0.7, metalness: 0.0 }
    return { roughness: baseRoughness, metalness: baseMetalness }
  }

  // Shadow opacity boost for white stars on white bg
  var SHADOW_BOOST = { "#FFFFFF": 0.12 }

  function updateViewer() {
    for (var i = 0; i < 4; i++) {
      var c = starColors[i],
        hex = c ? viewerHex(c.hex) : "#cccccc"
      var origUpper = c ? c.hex.toUpperCase() : ""
      var rules = getMaterialRules(c ? c.hex : "#cccccc")
      meshes[i].frontMat.color.set(hex)
      meshes[i].frontMat.roughness = rules.roughness
      meshes[i].frontMat.metalness = rules.metalness
      // White star gets gray edges so it doesn't vanish on white bg
      if (origUpper === "#FFFFFF") {
        meshes[i].edgeMat.color.set("#D8D8D8")
        meshes[i].edgeMat.roughness = 0.85
      } else {
        meshes[i].edgeMat.color.copy(tintToWhite(hex))
        meshes[i].edgeMat.roughness = rules.roughness + 0.05
      }
      meshes[i].edgeMat.metalness = rules.metalness
      var sOp = SHADOW_BOOST[origUpper] || shadowSettings.opacity
      shadowMeshes[i].material.opacity = sOp
    }
  }
  function slotSVG(i) {
    var c = starColors[i]
    if (!c)
      return (
        '<svg viewBox="' +
        VB +
        '" xmlns="http://www.w3.org/2000/svg" overflow="visible"><polygon points="' +
        SINGLE_PTS +
        '" fill="none" stroke="#ccc" stroke-width="12" stroke-dasharray="28 14" stroke-linejoin="round"/></svg>'
      )
    var iw = c.hex === "#FFFFFF"
    var fd = iw
      ? '<defs><filter id="ws' +
        i +
        '" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="2" stdDeviation="8" flood-color="#000" flood-opacity="0.2"/></filter></defs>'
      : ""
    var fa = iw ? 'filter="url(#ws' + i + ')"' : ""
    return (
      '<svg viewBox="' +
      VB +
      '" xmlns="http://www.w3.org/2000/svg" overflow="visible">' +
      fd +
      '<polygon points="' +
      SINGLE_PTS +
      '" fill="' +
      c.hex +
      '" stroke="none" ' +
      fa +
      "/></svg>"
    )
  }
  function swatchSVG(hex) {
    var iw = hex === "#FFFFFF"
    var fd = iw
      ? '<defs><filter id="wsg" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="2" stdDeviation="6" flood-color="#000" flood-opacity="0.18"/></filter></defs>'
      : ""
    var fa = iw ? 'filter="url(#wsg)"' : ""
    return (
      '<svg viewBox="' +
      VB +
      '" xmlns="http://www.w3.org/2000/svg" overflow="visible">' +
      fd +
      '<polygon points="' +
      SINGLE_PTS +
      '" fill="' +
      hex +
      '" stroke="none" ' +
      fa +
      "/></svg>"
    )
  }
  function buildStarRow() {
    var row = document.getElementById("star-row")
    row.innerHTML = ""
    for (var i = 0; i < 4; i++) {
      var c = starColors[i]
      var slot = document.createElement("div")
      slot.className = "star-slot" + (i === selectedSlot ? " active" : "")
      slot.innerHTML = slotSVG(i)
      var label = document.createElement("div")
      label.className = "slot-label"
      label.textContent = c ? c.name || c.hex : ""
      slot.appendChild(label)
      if (c) {
        var rm = document.createElement("div")
        rm.className = "slot-remove"
        rm.innerHTML = "&times;"
        ;(function (idx) {
          rm.onclick = function (e) {
            e.stopPropagation()
            starColors[idx] = null
            updateViewer()
            buildStarRow()
            buildColorGrid()
            updateBtn()
          }
        })(i)
        slot.appendChild(rm)
      }
      ;(function (idx) {
        slot.onclick = function () {
          selectedSlot = idx
          buildStarRow()
          buildColorGrid()
        }
      })(i)
      row.appendChild(slot)
    }
  }
  function buildColorGrid() {
    var grid = document.getElementById("color-grid")
    grid.innerHTML = ""
    var cur = starColors[selectedSlot]
    for (var k = 0; k < COLORS.length; k++) {
      var c = COLORS[k]
      var wrap = document.createElement("div")
      wrap.className = "color-star" + (cur && cur.hex === c.hex ? " selected" : "")
      wrap.innerHTML = swatchSVG(c.hex)
      wrap.title = c.name || c.hex
      ;(function (col) {
        wrap.onclick = function () {
          starColors[selectedSlot] = col
          updateViewer()
          for (var i = 1; i <= 3; i++) {
            var next = (selectedSlot + i) % 4
            if (!starColors[next]) {
              selectedSlot = next
              buildStarRow()
              buildColorGrid()
              return
            }
          }
          buildStarRow()
          buildColorGrid()
          updateBtn()
        }
      })(c)
      grid.appendChild(wrap)
    }
  }

  starMeshesContainers.push(meshes)
})

function updatePackViewer() {
  starMeshesContainers.forEach((starMeshes) => {
    starMeshes.forEach((mesh, i) => {
      const c = starColors[i]
      mesh.frontMat.color.set(c ? c.hex : 0xdddddd)
      mesh.frontMat.roughness = c ? 0.18 : 0.28
    })
  })
}

function updateStarColorCanvas(index, hex) {
  if (hex) {
    starColors[index] = { name: hex, hex }
  } else {
    starColors[index] = null
  }
}
